export default __webpack_public_path__ + "static/media/down-icon-active.31ee21f7.svg";